import { createSelector } from 'reselect'

const drawItSelector = state => state.drawIt

const drawItDeleteBackgroundImageSelector = createSelector(
	[ drawItSelector ],
	drawItState => ({
		iconBackground: drawItState.iconBackground,
	})
)

export default drawItDeleteBackgroundImageSelector
